'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/* \n* ink colors (with variations only for black and white)\n*/\n.lp__tabs--wrapper {\n  min-height: 100px;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.24);\n  border-radius: calc(0.5 * 1rem);\n  width: 50%;\n}\n.lp__tabs--wrapper .lp__tab--list {\n  border-bottom: 1px solid #ccc;\n  padding-left: 0;\n  height: 35px;\n  display: flex;\n  flex-wrap: nowrap;\n  flex: 0 1 0;\n  margin-bottom: 0;\n}\n.lp__tabs--wrapper .lp__tab--list .lp__tab--group {\n  display: inline-flex;\n  max-width: 90%;\n  overflow: scroll;\n  margin: 0 calc(0.75 * 1rem);\n  scrollbar-width: none;\n  /* For Firefox */\n  -ms-overflow-style: none;\n  /* For Internet Explorer and Edge */\n}\n.lp__tabs--wrapper .lp__tab--list .lp__tab--group::-webkit-scrollbar {\n  display: none;\n  /* For Chrome, Safari, and Opera */\n}\n.lp__tabs--wrapper .lp__tab--list .left__arrow {\n  margin-left: calc(0.5 * 1rem);\n}\n.lp__tabs--wrapper .lp__tab__list--item {\n  display: inline-block;\n  list-style: none;\n  margin-bottom: -1px;\n  padding: 0.5rem 0.75rem;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n.lp__tabs--wrapper .lp__tab__list--item:hover {\n  color: #1D66DD;\n}\n.lp__tabs--wrapper .lp__tab__list--active {\n  color: #1D66DD;\n  border-bottom: 2px solid #1D66DD;\n  font-weight: 500;\n}\n.lp__tabs--wrapper .lp__tabs--arrow {\n  font-size: 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.lp__tabs--wrapper .lp__tab--content {\n  padding: calc(0.75 * 1rem);\n}");
//# sourceMappingURL=Tabs.scss.js.map
